import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-batch',
  templateUrl: 'batch.html',
})
export class BatchPage {

  type: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.type = this.navParams.get("type");
  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/batch/batch.ts